'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.adminSummary', {
        url: '/admin-summary',
        templateUrl: 'app/adminSummary/adminSummary.html',
        controller: 'AdminSummaryCtrl',
				sp: {
					authenticate: true
				}
      });
  });